import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import imageOne from "Assets/images/NuestraCultura.jpg";
import arrowBtn from "Assets/icons/arrow_left.svg";

//styles
import "../Landing.scss";
import { trackEvent } from "Services/Analytics/trackEvent";

const Culture = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const ourCulture = () => {
    trackEvent("cultura_button");
    navigate("/about");
  };
  return (
    <section className="section landing-section">
      <div className="content">
        <h2 className="title">
          {t("culture.title1")} {t("culture.mark")}
        </h2>
        <p className="description">
          {t("culture.description1")}{" "}
          <mark className="mark-sky">{t("culture.mark2")}</mark>
          <br />
          <br />
          {t("culture.description2")}
          <br />
          <br />
          {t("culture.description3")}
        </p>
        <button
          onClick={ourCulture}
          className="button"
          aria-label={t("culture.textBtn")}
        >
          <img src={arrowBtn} width={24} height={24} alt="arrow rigth" />
          {t("culture.textBtn")}
        </button>
      </div>
      <img
        className="img"
        loading="lazy"
        src={imageOne}
        width={1920}
        height={1080}
        alt="nuestra cultura"
      />
    </section>
  );
};

export default Culture;
